import * as React from 'react';

export const AgentContentWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div style={{ marginTop: -24 }}>{children}</div>;
};

AgentContentWrapper.displayName = 'AgentContentWrapper';
